module.exports = __webpack_public_path__ + "static/media/fr.92d096f8.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/LanguageSwitcher/img/fr.png
 ** module id = 594
 ** module chunks = 0
 **/